module.exports = __webpack_public_path__ + "bdfe938855c17f29f71aba85ea930804.svg";